import React from "react";
import SocialMediaIcons from "../components/SocialMediaLinks";
import ConsoleTextAnimation from "../components/ConsoleTextAnimation";
function Home() {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ height: "85vh" }}
    >
      {/* Centered content */}
      <section className="container text-center">
        <div className="d-flex justify-content-center align-items-center mobile-setting padding-sides">
          <div className="container">
            {/* <p className="text-lg autotype">
              Hello. I like creating data-driven projects across different
              fields. I see any related role as a great learning opportunity,
              and each project as an enjoyable part of the journey.
            </p> */}
						<ConsoleTextAnimation></ConsoleTextAnimation>
          </div>
          <div className="flex-shrink-0 mt-2 image-border rounded-circle">
            <img
              src="/images/caner_pic_circle.png"
              alt=""
              width="250"
              className="img-fluid rounded-circle"
            />
          </div>
        </div>
      </section>
      <div className="mt-3">
        <SocialMediaIcons
          githubLink="https://github.com/canerIrfanoglu"
          mediumLink="https://medium.com/@caneradilirfanoglu"
          linkedinLink="https://www.linkedin.com/in/caner-irfanoglu-6868b077/"
          mailLink="canerirfanoglu@gmail.com"
					resume
        />
      </div>
    </div>
  );
}

export default Home;
